/* eslint-disable react/function-component-definition */
import type { ComponentType as FormComponentType } from '@lemonade-hq/cdk';
import type { UniclientComponent } from '@lemonade-hq/uniclient-chat';
import type { ComponentType, IntrinsicType, LayoutProps } from '@lemonade-hq/uniclient-theme';
import { Layout } from '@lemonade-hq/uniclient-theme';
import { forwardRef } from 'react';
import type { ForwardedRef, PropsWithChildren } from 'react';

export type WizardComponentAdapterProps<TElementType extends ComponentType = IntrinsicType> = PropsWithChildren<
  LayoutProps<TElementType>
> & {
  readonly type: UniclientComponent<string>['type'] | `${FormComponentType}`;
  readonly attribute?: string;
  readonly disableAnimation?: boolean;
};

export const WizardComponentAdapter = forwardRef(
  <TElementType extends ComponentType = IntrinsicType, TRef = unknown>(
    { children, attribute, type, disableAnimation = false, ...props }: WizardComponentAdapterProps<TElementType>,
    ref: ForwardedRef<TRef>,
  ): JSX.Element => {
    return (
      <Layout
        {...props}
        data-animated={!disableAnimation ? '' : undefined}
        data-attribute={attribute}
        data-type={type}
        ref={ref}
      >
        {children}
      </Layout>
    );
  },
) as <TElementType extends ComponentType = IntrinsicType, TRef = unknown>(
  props: WizardComponentAdapterProps<TElementType> & { readonly ref?: ForwardedRef<TRef> },
) => JSX.Element;
